import type { IntlShape } from "react-intl";

const DELIVERY_SERVICE_LEVEL_MESSAGES: Record<string, { id: string; defaultMessage: string }> = {
  "1": { id: "new-request.schedule.selectServiceLevel1Day", defaultMessage: "1 day" },
  "3": { id: "new-request.schedule.selectServiceLevel3Day", defaultMessage: "3 day" },
  "5": { id: "new-request.schedule.selectServiceLevel5Day", defaultMessage: "5 day" },
  "7": { id: "new-request.schedule.selectServiceLevel7Day", defaultMessage: "7 day" },
  NA: {
    id: "new-request.schedule.selectServiceLevelNA",
    defaultMessage: "Not Applicable - E.g. for Ocean freight",
  },
};

export const getDeliveryServiceLevelLabel = (intl: IntlShape, value: string): string => {
  const message = DELIVERY_SERVICE_LEVEL_MESSAGES[value];
  return message ? intl.formatMessage(message) : value;
};
